import type { ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useAisIdentity } from './useAisIdentity';

// Pages a web-AIS session does not open
export const AisHiddenRoute = ({ children }: { children: ReactElement }) =>
  useAisIdentity() ? <Navigate replace to="/dashboard" /> : children;
